export const gitRegex = /^git@(([0-9a-z_!~*'().&=+$%-]+: )?[0-9a-z_!~*'().&=+$%-]+@)?(([0-9]{1,3}.){3}[0-9]{1,3}|([0-9a-z_!~*'()-]+.)*([0-9a-z][0-9a-z-]{0,61})?[0-9a-z].[a-z]{2,6})(:[0-9]{1,4})?((\/?)|(\/[0-9a-z_!~*'().;?:@&=+$,%#-]+)+\/?)$/i

export const urlRegex = /^(http[s]?:)?\/\/[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/i

/*
 /^
    (http[s]?:)?\/\/  协议 'http://' or 'https://' or '//'
    (25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}  ip 地址
    (:([1-9]\d{0,3}|[1-5][0-9]{4}|6[0-4][0-9]{3}|65[0-4][0-9]{2}|655[0-2][0-9]|6553[0-5]))?  端口号
    (\/[-a-zA-Z0-9@:%_+.~#?&//=]*)?   资源路径
 $/i
*/
export const urlIpRegex = /^(http[s]?:)?\/\/(25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}(:([1-9]\d{0,3}|[1-5][0-9]{4}|6[0-4][0-9]{3}|65[0-4][0-9]{2}|655[0-2][0-9]|6553[0-5]))?(\/[-a-zA-Z0-9@:%_+.~#?&//=]*)?$/i

export const mobileRegex = /^1[0-9]{10}$/

export const emailRegex = /^[0-9a-zA-Z_]+@(([0-9a-zA-Z]+)[.]){1,2}[a-z]{2,3}$/

export const domainRegex = /^[a-zA-z0-9]+-?\w+(\.\w+)+/

// application/zip, application/x-zip-compressed, application/x-zip
export const zipRegex = /^application\/(zip|x-zip(-compressed)?)$/i

// 不是最完整的正则，部分生僻字可能不包含
export const CHINESS_REGEXP_STR = '[\\u4E00-\\u9FFF\\u3400-\\u4DFF]+'

// 图标分组名只能含：中文、英文、数字
export const ICON_GROUP_REGEXP = /^[\u4E00-\u9FFF\u3400-\u4DFFA-Z0-9]+$/ig

// 图标中文名包含：中文、英文、数字、中划线、下划线
export const ICON_CN_NAME_REGEXP = /^[\u4E00-\u9FFF\u3400-\u4DFFA-Z0-9_-]+$/ig

// 字段名称包含：英文、下划线
export const FIELD_EN_REGEXP = /^[a-zA-Z_]+$/i

// 包含数字字母下划线，字母开头，不得以下划线结尾，切不能包含2个连续下划线
export const FIELD_REGEXP = /^([a-zA-Z])(?!.*?_$)(?!.*_{2,})[a-zA-Z0-9_]{0,}$/

// 包含数字字母下划线中划线，字母开头，不得以下划线结尾，切不能包含2个连续下划线
export const FIELD_MID_REGEXP = /^([a-zA-Z])(?!.*?_$)(?!.*_{2,})[a-zA-Z0-9_-]{0,}$/

// 绝对和相对 url 地址
// eslint-disable-next-line no-useless-escape
export const apiRegex = /^[\/-a-zA-Z0-9@:~.#?&=_\{\}]+$/i
